import React from "react";
import { Offcanvas } from "react-bootstrap";
import moment from "moment";
import "../../../Assets/Styles/component.css";

const MorningBriefingMarketShareDetailModal = ({
  showDetail,
  setShowDetail,
  marketShareData,
}) => {
  return (
    <Offcanvas
      show={showDetail}
      onHide={() => setShowDetail(false)}
      placement="end"
      className="mb-detail-offcanvas"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          MORNING BRIEFING → MARKET SHARE DETAIL
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        <div className="mb-detail-header">
          <h3 className="mb-detail-title">MPI • ARI • RGI — Weekly</h3>
        </div>
        <div className="mb-section">
          <table className="mb-detail-table">
            <thead>
              <tr>
                <th className="mb-detail-th mb-detail-th-left">WEEK</th>
                <th className="mb-detail-th mb-detail-th-center">MPI</th>
                <th className="mb-detail-th mb-detail-th-center">ARI</th>
                <th className="mb-detail-th mb-detail-th-center">RGI</th>
              </tr>
            </thead>
            <tbody>
              {marketShareData && marketShareData.length > 0 ? (
                marketShareData.map((item, index) => {
                  let weekLabel = `Wk-${marketShareData.length - index}`;
                  if (item.week_start_date && item.week_end_date) {
                    const start = moment(item.week_start_date).format("MM/DD");
                    const end = moment(item.week_end_date).format("MM/DD");
                    weekLabel = (
                      <>
                        <div >
                          <span style={{ fontWeight: 500 }}>
                            {weekLabel}
                          </span>
                          <span style={{ fontSize: "0.65em", color: "#64748b", marginTop: "2px" }}>
                            {" "} ({start} - {end})
                          </span>
                        </div>
                      </>
                    );
                  }

                  const mpi = parseFloat(item.mpi) || 0;
                  const ari = parseFloat(item.ari) || 0;
                  const rgi = parseFloat(item.rgi) || 0;

                  const getColor = (val) => (val < 100 ? "#d97706" : "#0f172a"); // orange for < 1, dark for >= 1

                  return (
                    <tr key={index}>
                      <td className="mb-detail-td mb-detail-td-left">
                        {weekLabel}
                      </td>
                      <td
                        className="mb-detail-td mb-detail-td-center"
                        style={{ color: getColor(mpi) }}
                      >
                        {mpi.toFixed(2)}
                      </td>
                      <td
                        className="mb-detail-td mb-detail-td-center"
                        style={{ color: getColor(ari) }}
                      >
                        {ari.toFixed(2)}
                      </td>
                      <td
                        className="mb-detail-td mb-detail-td-center"
                        style={{ color: getColor(rgi) }}
                      >
                        {rgi.toFixed(2)}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" className="mb-detail-no-data">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MorningBriefingMarketShareDetailModal;
